import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const getDepartment = (payload, userName) => {
    return api.makeRequest({
        url: `/crm/getAllDept?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const createDepartment = (payload) => {
    return api.makeRequest({
        url: `/crm/createDept`,
        method: 'POST',
        data: payload
    })
}

export const updateDepartment = (payload) => {
    return api.makeRequest({
        url: `/crm/updateDept`,
        method: 'POST',
        data: payload
    })
}

export const deleteDepartment = (payload) => {
    return api.makeRequest({
        url: `/crm/deleteDept`,
        method: 'POST',
        data: payload
    })
}